export default __webpack_public_path__ + "static/blob15-5d3746cb1f3a9219f49aba25544b3032.svg";